import React from 'react';
import { Modal, Button, ListGroup } from 'react-bootstrap';

interface Group {
  id: string;
  name: string;
  teamCount: number;
}

interface GroupSelectionModalProps {
  show: boolean;
  onHide: () => void;
  groups: Group[];
  onSelectGroup: (groupId: string) => void;
  fixtureName: string;
}

const GroupSelectionModal: React.FC<GroupSelectionModalProps> = ({
  show,
  onHide,
  groups,
  onSelectGroup,
  fixtureName
}) => {
  const handleGroupSelect = (groupId: string) => {
    onSelectGroup(groupId);
    onHide();
  };

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>Select Group for Fixtures</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p className="text-muted mb-3">
          Select which group you want to add fixtures for in <strong>{fixtureName}</strong>
        </p>
        
        {groups.length > 0 ? (
          <ListGroup>
            {groups.map((group) => (
              <ListGroup.Item
                key={group.id}
                action
                onClick={() => handleGroupSelect(group.id)}
                className="d-flex justify-content-between align-items-center"
              >
                <div>
                  <strong>{group.name}</strong>
                  <br />
                  <small className="text-muted">{group.teamCount} teams</small>
                </div>
                <Button variant="outline-primary" size="sm">
                  Select
                </Button>
              </ListGroup.Item>
            ))}
          </ListGroup>
        ) : (
          <div className="text-center py-4">
            <p className="text-muted">No groups available. Please create a group first.</p>
            <Button variant="primary" onClick={onHide}>
              Create Group
            </Button>
          </div>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="outline-secondary" onClick={onHide}>
          Cancel
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default GroupSelectionModal;
